<template>
  <div v-if="EditItem">
    <el-dialog :visible.sync="dialogshow" :close-on-click-modal="false" :modal-append-to-body="false"
      :destroy-on-close="true" @close="closeDialog" width="800px" custom-class="cus_dialog">
      <div slot="title" class="flexBetween">
        <span style="color: #ffffff;">{{ EditItem.title1 }}</span>
      </div>
      <div>
        <el-form :model="EditItem" ref="EditItem" label-width="120px" v-if="EditItem">
          <el-row style="padding-top: 10px;">
            <el-col :span="10">
              <el-form-item label="教师姓名">
                <el-input v-model="EditItem.teacher_name" disabled style="width:180px"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="10">
              <el-form-item label="班级名称">
                <el-select v-model="EditItem.class_id" filterable placeholder="请选择班级" style="width:180px"
                  :disabled="disabled">
                  <el-option v-for="(item, idx) in EditItem.teacherClassList" :key="idx" :label="item.name"
                    :value="item.id" filterable:true></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="案例内容">
            <el-col :span="22">
              <div style="line-height: initial; width: 100%; ">
                <UEditor ref="ue" @ready="editorReady" style="width: 100%; "></UEditor>
              </div>
            </el-col>
          </el-form-item>

          <el-form-item label="备注">
            <el-col :span="22">
              <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 50 }" v-model="EditItem.remarks"
                :disabled="disabled"></el-input>
              <div style="text-align:right">{{ EditItem.remarks.length }}</div>
            </el-col>
          </el-form-item>

          <el-row style="padding-top: 10px;">
            <el-col :span="10">
              <el-form-item label="填报时间">
                <el-date-picker v-model="EditItem.report_time" :disabled="disabled" style="width:180px" align="right"
                  type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="排序号">
                <el-input-number v-model="EditItem.sort" :disabled="disabled" controls-position="right"
                  style="width:180px"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <el-row>
          <el-col :span="22" style="text-align: right;padding-left: 10px;"
            v-if="$store.state.teacher.id == EditItem.create_id || EditItem.id == 0">
            <el-button size="small" icon="el-icon-edit" type="primary" @click="submitForm()">提交</el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import UEditor from "../notify/ueditor.vue";
import util from "../../utils/util.js";
export default {
  components: { UEditor },
  props: ["id"],
  data() {
    return {
      dialogshow: true,
      disabled: true,
      editor: null,
      optionsRow: {
        remarks: "",
        class_name: "",
        class_id: 0,
        teacher_name: "",
        teacher_id: 0,
        case_content: "",
        report_time: ""
      },
      EditItem: {
        teacherClassList: [],
        is_draft: 1,
        title1: "",
        id: 0,
        remarks: "",
        class_name: "",
        class_id: 0,
        teacher_name: "",
        teacher_id: 0,
        create_id: 0,
        case_content: "",
        report_time: "",
        create_name: "",
        sort: 99
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            }
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            }
          }
        ]
      },
      loading: false
    };
  },
  mounted() {
    this.$$parent(this, "EditItem").then(res => {
      if (res.id == 0) {
        //新增
        res.report_time = util.formatDate(new Date());
        this.disabled = false;
      } else {
        if (this.$store.state.teacher.id == res.create_id) {
          //我发起的
          this.disabled = false;
          res.is_draft = 1;
        } else {
          //不是我的
        }
        setTimeout(() => {
          this.editor.setContent(this.EditItem.case_content);
        }, 500);
      }
      this.EditItem = res;
    });
  },
  methods: {
    closeDialog() {
      this.$$parent(this, "dialogshow", false);
    },
    submitForm(st) {
      let data = JSON.parse(JSON.stringify(this.EditItem));
      if (data.case_content.length < 50) {
        this.$message.error("优秀事迹简介必须大于50字!");
        return false;
      }
      if (!data.report_time.trim()) {
        this.$message.error("填报时间必选!");
        return false;
      }
      if (!data.class_id) {
        this.$message.error("班级必选!");
        return false;
      }
      this.$http.post("/api/typical_case_edit", data).then(res => {
        this.$message({
          type: "success",
          message: "提交成功"
        });
        this.$$parent(this, "getList");
        this.$$parent(this, "dialogshow", false);
      });
    },
    editorReady(editorInstance) {
      editorInstance.setContent(this.EditItem.case_content);
      editorInstance.addListener("contentChange", () => {
        this.EditItem.case_content = editorInstance.getContent();
      });
      this.editor = editorInstance;
    }
  }
};
</script>

<style scoped>
.imgaddbtn {
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px dotted #ccc;
  font-size: 30px;
  cursor: pointer;
}

.imgremove {
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;

  cursor: pointer;
  position: absolute;
  top: -5px;
  right: -5px;
  color: #ccc;
}

.imgremove:hover {
  color: orange;
}
</style>
